import type { RouteLocationNormalized, RouteLocationRaw, RouteRecordRaw } from 'vue-router';
import ROUTE_NAMES from '@/vue/routes/routeNames';
import { useUserStore } from '@/vue/stores/user';

const CueEntrypoint = () => import('./views/CueEntrypoint.vue');
const CueLogin = () => import('./views/CueLogin.vue');
const ActivityView = () => import('./views/ActivityView.vue');
const ActivityWaitingView = () => import('./views/ActivityWaitingView.vue');
const ActivityInformatingView = () => import('./views/ActivityInformatingView.vue');
const ActivityTimerView = () => import('./views/ActivityTimerView.vue');
const ActivityEvaluatingView = () => import('./views/ActivityEvaluatingView.vue');
const ActivityFinishingView = () => import('./views/ActivityFinishingView.vue');
const TrackCompletedView = () => import('./views/TrackCompletedView.vue');

const cueSessionGuard = (
    to: RouteLocationNormalized,
): RouteLocationRaw | boolean => {
    const { sessionTrack } = to.params as { sessionTrack: string };

    const isLoginRoute = to.name === ROUTE_NAMES.CUE_LOGIN;
    const isEntrypointRoute = to.name === ROUTE_NAMES.CUE_ENTRYPOINT;
    const isCompletedRoute = to.name === ROUTE_NAMES.CUE_TRACK_COMPLETED;

    if (!useUserStore().isUserLoggedIn && !isLoginRoute && !isCompletedRoute) {
        return { name: ROUTE_NAMES.CUE_LOGIN, params: { sessionTrack }, query: to.query };
    }

    if (useUserStore().isUserLoggedIn && (isLoginRoute || isEntrypointRoute)) {
        return {
            name: ROUTE_NAMES.CUE_ACTIVITY_VIEW,
            params: { sessionTrack }, query: to.query,
        };
    }

    return true;
};

export default [
    {
        path: '/cue/session-track/:sessionTrack',
        name: ROUTE_NAMES.CUE_ENTRYPOINT,
        component: CueEntrypoint,
        beforeEnter: cueSessionGuard,
        meta: {
            title: 'CUE Session',
            anonymous: true,
            hideMenu: true,
        },
        children: [
            {
                path: 'login',
                name: ROUTE_NAMES.CUE_LOGIN,
                component: CueLogin,
            },
            {
                path: 'activity',
                name: ROUTE_NAMES.CUE_ACTIVITY_VIEW,
                component: ActivityView,
                children: [
                    {
                        path: 'waiting',
                        name: ROUTE_NAMES.CUE_ACTIVITY_WAITING,
                        component: ActivityWaitingView,
                    },
                    {
                        path: 'informating',
                        name: ROUTE_NAMES.CUE_ACTIVITY_INFORMATING,
                        component: ActivityInformatingView,
                    },
                    {
                        path: 'timer',
                        name: ROUTE_NAMES.CUE_ACTIVITY_TIMER,
                        component: ActivityTimerView,
                    },
                    {
                        path: 'evaluating',
                        name: ROUTE_NAMES.CUE_ACTIVITY_EVALUATING,
                        component: ActivityEvaluatingView,
                    },
                    {
                        path: 'finishing',
                        name: ROUTE_NAMES.CUE_ACTIVITY_FINISHING,
                        component: ActivityFinishingView,
                    },
                ],
            },
            {
                path: 'completed',
                name: ROUTE_NAMES.CUE_TRACK_COMPLETED,
                component: TrackCompletedView,
            },
        ],
    },
] satisfies RouteRecordRaw[];
